import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';
import StoreCardList from '../StoreCardList';

import White from '../../../assets/img/sample/White.jpg';
import Red from '../../../assets/img/sample/Red.jpg';
import Rose from '../../../assets/img/sample/Rose.jpg';
import Sparkling from '../../../assets/img/sample/Sparkling.jpg';
import Cider from '../../../assets/img/sample/Cider.jpg';
import Glass from '../../../assets/img/sample/glass.jpg';

const SPOTLIGHT_ITEMS = [
  { id: 'spot-1', name: 'Farmhouse White (750ml)',  price: '$14.99', info: 'Crisp • Notes of citrus',             img: White },
  { id: 'spot-2', name: 'Heritage Red (750ml)',     price: '$16.99', info: 'Bold • Dark berry & spice',           img: Red },
  { id: 'spot-3', name: 'Dry Rosé (750ml)',         price: '$13.99', info: 'Refreshing • Summer fruit',           img: Rose },
  { id: 'spot-4', name: 'Sparkling Brut (750ml)',   price: '$18.99', info: 'Small-batch • Traditional method',    img: Sparkling },
  { id: 'spot-5', name: 'Farm Apple Cider (1L)',    price: '$6.99',  info: 'Cold-pressed • Unfiltered',          img: Cider },
  { id: 'spot-6', name: 'Tasting Glass Set (2pc)',  price: '$9.99',  info: 'Etched logo • Gift-ready',           img: Glass },
];

export default function FarmSpotlight({ title = 'Farm itmes', to, farmName = 'Mockridge Farm', sponsored = true }) {
  const LIMIT = 6;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={StoreStyle['spotlight-section']}>
      <div className={StoreStyle['spotlight-inner']}>

        {/* Header band */}
        <div className={StoreStyle['spotlight-head']}>
          <div className={StoreStyle['featured-header']}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
            </div>
            {to ? <Link to={to} style={{ color: '#16a34a', fontWeight: 600 }}>See all</Link> : null}
          </div>
        </div>

        {/* Meta row */}
        <div className={StoreStyle['spotlight-meta']}>
          <div className={StoreStyle['spotlight-chip']} aria-hidden="true">🌿</div>
          <div>
            Featured farm: <span style={{ color: '#0f766e', fontWeight: 600 }}>{farmName}</span>
          </div>
        </div>

        {/* Product rail */}
        <div className={StoreStyle['swiper-rail']}>
          <StoreCardList
            items={SPOTLIGHT_ITEMS}
            loading={loading}
            onBuy={(item) => console.log('Buy clicked:', item)}
            skeletonCount={LIMIT}
          />
        </div>
      </div>
    </section>
  );
}